var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-24 md:w-32 absolute top-2 right-0 mr-4 language-selector-main"},[_c('v-select',{attrs:{"items":_vm.languages,"label":"Language","outlined":"","value":_vm.locale,"dense":""},on:{"change":_vm.setLanguage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }